import { html, TemplateResult } from '@rxdi/lit-html';

export type RichToken = { text: string; mark: 'plain' | 'accent' | 'bold' };

/**
 * Splits admin-edited text into plain / [accent] / **bold** runs. Pure and
 * HTML-free: the result is rendered as text, so content can never inject markup.
 */
export function parseRich(text: string): RichToken[] {
  const tokens: RichToken[] = [];
  const re = /\[([^\]]+)\]|\*\*([^*]+)\*\*/g;
  let last = 0;
  let m: RegExpExecArray | null;
  const source = text ?? '';
  while ((m = re.exec(source))) {
    if (m.index > last) tokens.push({ text: source.slice(last, m.index), mark: 'plain' });
    tokens.push(m[1] !== undefined ? { text: m[1], mark: 'accent' } : { text: m[2], mark: 'bold' });
    last = re.lastIndex;
  }
  if (last < source.length) tokens.push({ text: source.slice(last), mark: 'plain' });
  return tokens;
}

/** "Shipped and [live]." -> Shipped and <em>live</em>.   "**bold**" -> <strong>bold</strong> */
export function rich(text: string): TemplateResult {
  return html`${parseRich(text).map((t) =>
    t.mark === 'accent' ? html`<em>${t.text}</em>` : t.mark === 'bold' ? html`<strong>${t.text}</strong>` : t.text
  )}`;
}

/** The text without markers (for titles, alt text, meta tags). */
export const plain = (text: string) =>
  parseRich(text)
    .map((t) => t.text)
    .join('');
